import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';

@Component({
  selector: 'app-rail-seat-auto-warning-modal',
  templateUrl: './rail-seat-auto-warning-modal.component.html',
  styleUrl: './rail-seat-auto-warning-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class RailSeatAutoWarningModalComponent {
  constructor(public activeModal: NgbActiveModal) {}

  async closeModal(userOk: boolean): Promise<void> {
    this.activeModal.close(userOk);
  }
}
LightningModalTypes.RailSeatAutoWarningModalComponent.component = RailSeatAutoWarningModalComponent;
